export default __webpack_public_path__ + "static/media/028-fireworks.4a3e922e.svg";